export const PROFICIENCY_MAPPING = {
    'unspecified': 0,
    'basic': 1,
    'conversational': 2,
    'fluent': 3,
    'native_or_bilingual': 4
};
